// =============================================================================
// Admin Page - 管理员页面路由
// =============================================================================

import React from 'react';
import { Routes, Route, Navigate, Link } from 'react-router-dom';
import {
  Settings,
  Users,
  Database,
  BarChart3,
  FileText,
  Shield,
  ArrowLeft,
  Terminal
} from 'lucide-react';
import AdminTemplatesPage from './AdminTemplatesPage';

const AdminPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="flex h-screen">
        {/* Sidebar */}
        <div className="w-64 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 flex flex-col">
          {/* Header */}
          <div className="p-4 border-b border-gray-200 dark:border-gray-700">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <Terminal className="w-5 h-5 text-white" />
              </div>
              <span className="text-lg font-semibold text-gray-900 dark:text-white">
                管理面板
              </span>
            </div>
            <Link
              to="/dashboard"
              className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              返回主界面
            </Link>
          </div>

          {/* Navigation */}
          <div className="flex-1">
            <nav className="space-y-2">
              <Link
                to="/admin/overview"
                className="flex items-center gap-3 px-3 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
              >
                <BarChart3 className="w-4 h-4" />
                系统概览
              </Link>
              <Link
                to="/admin/templates"
                className="flex items-center gap-3 px-3 py-2 bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900/30 rounded-md"
              >
                <FileText className="w-4 h-4" />
                模板管理
              </Link>
              <Link
                to="/admin/users"
                className="flex items-center gap-3 px-3 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
              >
                <Users className="w-4 h-4" />
                用户管理
              </Link>
              <Link
                to="/admin/system"
                className="flex items-center gap-3 px-3 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
              >
                <Settings className="w-4 h-4" />
                系统设置
              </Link>
              <Link
                to="/admin/security"
                className="flex items-center gap-3 px-3 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
              >
                <Shield className="w-4 h-4" />
                安全设置
              </Link>
              <Link
                to="/admin/database"
                className="flex items-center gap-3 px-3 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md"
              >
                <Database className="w-4 h-4" />
                数据库管理
              </Link>
            </nav>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 overflow-auto">
        <Routes>
          <Route index element={<Navigate to="templates" replace />} />
          <Route path="templates" element={<AdminTemplatesPage />} />
          <Route path="overview" element={<AdminOverviewPage />} />
          <Route path="users" element={<AdminUsersPage />} />
          <Route path="system" element={<AdminSystemPage />} />
          <Route path="security" element={<AdminSecurityPage />} />
          <Route path="database" element={<AdminDatabasePage />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

// Placeholder components for other admin pages
const AdminOverviewPage = () => (
  <div className="p-6">
    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">系统概览</h1>
    <p className="text-gray-600 dark:text-gray-400 mt-2">系统统计和监控信息</p>
  </div>
);

const AdminUsersPage = () => (
  <div className="p-6">
    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">用户管理</h1>
    <p className="text-gray-600 dark:text-gray-400 mt-2">用户账户管理和权限设置</p>
  </div>
);

const AdminSystemPage = () => (
  <div className="p-6">
    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">系统设置</h1>
    <p className="text-gray-600 dark:text-gray-400 mt-2">系统配置和参数设置</p>
  </div>
);

const AdminSecurityPage = () => (
  <div className="p-6">
    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">安全设置</h1>
    <p className="text-gray-600 dark:text-gray-400 mt-2">安全策略和访问控制</p>
  </div>
);

const AdminDatabasePage = () => (
  <div className="p-6">
    <h1 className="text-2xl font-bold text-gray-900 dark:text-white">数据库管理</h1>
    <p className="text-gray-600 dark:text-gray-400 mt-2">数据库维护和备份管理</p>
  </div>
);

export default AdminPage;
